import { Modal } from 'antd';
import axios from 'axios';
import authServices from './auth.service';
import {
  API_END_POINT_USER,
  API_END_POINT_PRODUCT,
  API_END_POINT_OFFER,
  API_END_POINT_INTEGRATION,
  API_END_POINT_EMAIL,
} from '../constants/api.constant';

export const HOST = {
  USER_SERVICE: API_END_POINT_USER,
  PRODUCT_SERVICE: API_END_POINT_PRODUCT,
  OFFER_SERVICE: API_END_POINT_OFFER,
  INTEGRATION_SERVICE: API_END_POINT_INTEGRATION,
  UTILITIES_SERVICE: API_END_POINT_EMAIL,
};

const axiosClient = axios.create({
  // baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'content-type': 'application/json',
  },
});
// handle response error
const handleError = (error) => {
  if (error.response) {
    const { status, data } = error.response;
    switch (status) {
      case 401:
        Modal.error({
          title: 'Your session is expired. Please log in.',
          content: '',
          centered: true,
          onOk() {
            authServices.directLogout();
            return Promise.reject(data);
          },
          onCancel() {
            authServices.directLogout();
            return Promise.reject(data);
          },
        });
        return Promise.reject(data);
      case 400:
        if (data.alerts && data.alerts.length > 0 && data.alerts[0]?.code.startsWith('ER')) {
          Modal.error({
            title: data.alerts[0]?.message,
            content: '',
            centered: true,
          });
          return Promise.reject(data);
        }
        if (data.message && data.message) {
          Modal.error({
            title: data.error,
            content: data.message,
            centered: true,
          });
          return Promise.reject(data);
        }
        return Promise.reject(data);
      case 500:
        if (data.message && data.message) {
          Modal.error({
            title: data.error,
            content: data.message,
            centered: true,
          });
          return Promise.reject(data);
        }
        return Promise.reject(data);
      default:
        return Promise.reject(data);
    }
  }
  return Promise.reject(error);
};
axiosClient.interceptors.request.use(async (config) => {
  const token = localStorage.getItem('user');

  if (token) {
    config.headers.Authorization = `${token}`;
  }
  // handle token here
  return config;
});

axiosClient.interceptors.response.use(
  // eslint-disable-next-line arrow-body-style
  (response) => {
    return response;
  },
  // eslint-disable-next-line arrow-body-style
  handleError,
);

export default axiosClient;
